import React from "react";
import { formatTime } from "./helpers";

interface HourMarkerProps {
  hour: Date;
}

const classes = {
  Wrapper: "relative h-[60px]",
  HourMarker: "hour-marker flex items-start",
  HourLabel:
    "text-xs text-neutral-300 w-16 -mt-2 pr-2 text-right left-0 bg-red",
  HalfHourMarker:
    "absolute top-[30px] left-16 right-0 border-t border-neutral-300 border-dashed"
};

export const HourMarker: React.FC<HourMarkerProps> = ({ hour }) => {
  return (
    <div className={classes.Wrapper}>
      {/* Hour marker with label */}
      <div className={classes.HourMarker}>
        <div className={classes.HourLabel}>
          {formatTime(hour).replace(":00", "")}
        </div>
        <div className="flex-1 border-[#CFD3D6] border-t" />
      </div>

      {/* Half-hour marker (no label) */}
      <div className={classes.HalfHourMarker} />
    </div>
  );
};
